// extracted by mini-css-extract-plugin
export default {"borderColor":"#eaebf0","scrollBarTrack":"#f1f1f1","scrollBar":"#c5c5c5"};